import React, { Component } from "react";
import { Form, Row, Col, Button, ListGroup, Alert, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";


import ReactTable from "react-table";
import "containers/common/List.css";
import Moment from "moment";
import DatePicker from "react-datepicker";
import Select from 'react-select';

export default class PropertyArticleList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            data: [],
            selectedArticleCategory: {},
            dataSet: "propertyArticles",
            dataRecord: "propertyArticles",
            dataSetPrimaryKey: "article_property_link_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        this.setState({ isLoading: true });     
        if (!this.props.isAuthenticated) { // if false
            return;
        }  
        const data = this.props.data;
        this.setState({ data });      

        this.setState({ isLoading: false });      
    }

    componentDidUpdate(prevProps) {

        if (this.props.data !== prevProps.data) {
            const data = this.props.data;
            this.setState({ data });
        }

    }


    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }



    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        if(cellInfo.column.id=="property_key"){
            data[cellInfo.index][cellInfo.column.id] = event.target.value.toUpperCase();
        }
        else{
            data[cellInfo.index][cellInfo.column.id] = event.target.value;
        }
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(event);
        data[cellInfo.index][cellInfo.column.id] = dt.toLocaleDateString('en-AU',options);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);

    }


    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.unshift({
            property_id: null,
            property_key: "",         
            article_id: this.props.articleid,
            article_date: null,
            source: "",
            brief_description: "",
            article_category_code: "",
            file_name: "",
            file_type: null,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }


    renderEditable =  cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];
        
           

        
       

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    handleFilterChange = (selectedArticleCategory) => {
        console.log(selectedArticleCategory);
        this.setState({
            selectedArticleCategory: selectedArticleCategory
        });
        if (selectedArticleCategory) {
            let data = [];
            const oldData = [...this.state.data];

            var i
            for (i = 0; i < oldData.length; i++) {
                console.log(oldData[i]);
                if (oldData[i].hasOwnProperty("article_category_code")) {
                    if (oldData[i].article_category_code === selectedArticleCategory.value) {
                        data.push(oldData[i])
                    }
                }
            }
            this.setState({ data });

        }
        else {
            const data = [...this.props.data];
            this.setState({ data });
        }

    }


    renderTable(data) {
        const columns = [
            {
                id: 'article_property_link_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'article_property_link_id'
                

        },
            {
                id: 'article_id',
                Header: 'Article ID',
                maxWidth: 60,
                accessor: 'article_id',
                Cell: e => <LinkContainer to={{pathname: `../articles/${e.value}`, state: {propertyidlist: this.props.idList}}}><a> {e.value} </a></LinkContainer>
                

        }, {
                id: 'source',
                Header: 'Source',
                accessor: 'source',
                maxWidth: 200

            }, {
                id: 'brief_description',
                Header: 'Description',
                accessor: 'brief_description',
                maxWidth: 400

            },
            {
                id: 'category',
                Header: 'Article Category',
                accessor: 'category',
                maxWidth: 200

            }, {
                id: 'article_date',
                Header: 'Article Date',
                accessor: d => {
                    if (d.article_date) {
                        return Moment(d.article_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 105,
                style: { textAlign: "center" }

            },
            {
                id: 'file_name',
                Header: 'File Name',
                accessor: 'file_name',
                maxWidth: 400,
                Cell: r=> <a target="_blank" rel="noopener noreferrer" href={r.original.url} > {r.value +"."+r.original.file_type}  </a>
                //  this.renderEditable

            },
            {
                id: 'file_type',
                Header: 'File Type',
                accessor: 'file_type',
                maxWidth: 105

            },
            {
                Header: '',
                accessor: 'article_property_link_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <div>
                    
                    <Form.Group as={Row}  controlId="selectedArticleCategory" >
                        <Col sm={2} md={2} lg={1}>
                    <Form.Label className="text-right"  >Article Category</Form.Label>
                        </Col>
                        <Col sm={4} md={4} lg={4}>
                    <Select
                        value={this.state.selectedArticleCategory}
                        onChange={this.handleFilterChange}
                        options={this.props.articleCategories}
                            onBlur={this.handleBlur}
                            isClearable
                            />
                            </Col>
                    
                </Form.Group>
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                    />
                    </div>
            )
        }



    }


    renderTable2(data) {
        const columns = [
            {
                id: 'article_property_link_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'article_property_link_id'

            },
            {
                id: 'article_id',
                Header: 'Article ID',
                maxWidth: 60,
                accessor: 'article_id'

            }, {
                id: 'property_key',
                Header: 'Cityscope Reference',
                accessor: 'property_key',
                maxWidth: 200,
                Cell: this.renderEditable
            }
           ,
            {
                Header: '',
                accessor: 'article_property_link_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }

    }
    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ? <LinkContainer to={ {pathname: `/properties/${d.property_key}`, state: {tab: "articles", data: (this.props.propertyidlist||[]).indexOf(d.property_key)>=0?this.props.propertyidlist:[]}}} >
                            <ListGroup.Item key={i} as="a" header={d.property_key}>
                                {d.property_key}
                            </ListGroup.Item>
                        </LinkContainer>
                        : ""
            );
        }
    }

    
    
    renderComponent() {
        return (
            <div className="ArticleData">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {(this.props.controlType === "table" || this.props.controlType === "table2") && <Row >
                    <Col className="text-right" >
                        {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        {this.props.controlType === "table" && <LinkContainer to={`/properties/${this.props.propertykey}/articles/new?propertyid=${this.props.propertyid}`}><Button variant="secondary" size="sm">Add</Button></LinkContainer>}
                        {this.props.controlType === "table2" && <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>}

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType == "table" ? this.renderTable(this.state.data) : this.props.controlType == "table2" ? this.renderTable2(this.props.data) : this.renderList(this.props.data)}
                        </Col>
                    </Row>
        

            </div>
        );
    }
  render() {
    return (

        <div className="ArticleSection">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
